import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import Center from '../../../../../../packages/kiti/components/helpers/Center'
import Counter from './Counter'
import CounterTitle from './CounterTitle'
import PeriodDescription from '../../PeriodDescription'
import ProgressBar from './ProgressBar'
import ProgressChart from './ProgressChart'

const CounterChart = props => {
  return (
    <Center height="100%" width="100%" justify="flex-start">
      <Col width="100%">
        <Grid align="center">
          <Col flex={1}>
            <Counter {...props} />
            <CounterTitle {...props} />
            <PeriodDescription marginLeft={1.4} marginTop={-0.1} marginBottom={-0.6} />
            <ProgressBar {...props} />
          </Col>
          <Col>
            <ProgressChart {...props} />
          </Col>
        </Grid>
      </Col>
    </Center>
  )
}

export default CounterChart
